/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Contract_ReferenceInputs */

const en_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract reference`)
};

const de_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertragsreferenz`)
};

const fr_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Référence du contrat`)
};

const es_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referencia del contrato`)
};

const it_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riferimento del contratto`)
};

const nl_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contractreferentie`)
};

const pl_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numer referencyjny umowy`)
};

const fi_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sopimusviite`)
};

const da_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontraktreference`)
};

const sv_consumer_declaration_contract_reference = /** @type {(inputs: Consumer_Declaration_Contract_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avtalsreferens`)
};

/**
* | output |
* | --- |
* | "Contract reference" |
*
* @param {Consumer_Declaration_Contract_ReferenceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_contract_reference = /** @type {((inputs?: Consumer_Declaration_Contract_ReferenceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Contract_ReferenceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_contract_reference(inputs)
	if (locale === "fr") return fr_consumer_declaration_contract_reference(inputs)
	if (locale === "es") return es_consumer_declaration_contract_reference(inputs)
	if (locale === "it") return it_consumer_declaration_contract_reference(inputs)
	if (locale === "nl") return nl_consumer_declaration_contract_reference(inputs)
	if (locale === "pl") return pl_consumer_declaration_contract_reference(inputs)
	if (locale === "fi") return fi_consumer_declaration_contract_reference(inputs)
	if (locale === "da") return da_consumer_declaration_contract_reference(inputs)
	if (locale === "sv") return sv_consumer_declaration_contract_reference(inputs)
	return en_consumer_declaration_contract_reference(inputs)
});